
<!-- Met eigenKnop geeft de pagina zelf de knop mee (Live: de accountregel
     rechtsboven in de stijl van de studio-app); het menu is hetzelfde. -->
@if (eigenKnop) {
  <button [cdkMenuTriggerFor]="menu" class="btn-none eigen-knop" type="button">
    <ng-content></ng-content>
  </button>
} @else {
<button [cdkMenuTriggerFor]="menu" class="btn-none menu-button">
  <div class="avatar-info">
    <div class="avatar">
      <img [src]="avatar$ | async"
           appGGImage
           class="avatar-image"
           defaultImage="/assets/images/default-avatar.jpg"
           alt="avatar">
    </div>

    <div class="profile">
      <span class="profile-name">{{ user.firstName }} {{ user.lastName }}</span>
      <!-- Welke club er aangemeld is: het logo links kan het PlayStats-logo
           zijn (club zonder logo), en een super-admin die als club opent ziet
           anders niet voor welke club hij werkt (eigenaar 23-09-2026: "ik zou
           ook graag de clubnaam ergens in de header hebben staan"). -->
      @if (user.club_name) {
        <span class="profile-club" [title]="user.club_name">{{ user.club_name }}</span>
      }
      <!-- Meekijken in een league-omgeving of de kijkrol club_viewer
           (docs/QFA-LEAGUE-OMGEVING.md): hier kun je niets wijzigen, en dat
           moet je zien voordat je het probeert. -->
      <!-- Een club die een super-admin opende (clubkiezer, 24-10-2026): je
           werkt in de omgeving van een klant, met clubbeheerrechten. -->
      @if (meekijken) {
        <!-- Een super-admin die als deze gebruiker meekijkt ("Open as user",
             25-10-2026): alleen kijken, en dat moet je zien. -->
        <span class="profile-alleen-kijken">{{ 'MEEKIJKEN.label' | translate }}</span>
      } @else if (beheerderInClub) {
        <span class="profile-alleen-kijken">{{ 'CLUB_KIEZER.label' | translate }}</span>
      } @else if (alleenKijken) {
        <span class="profile-alleen-kijken">{{ 'HEADER.omgeving.alleen_kijken' | translate }}</span>
      } @else if (draagtBijAanLeague) {
        <span class="profile-alleen-kijken">{{ 'HEADER.omgeving.bijdragen' | translate }}</span>
      }

      <!-- De opslag van de club: niet voor een speler (de gateway geeft hem die
           cijfers ook niet, docs/SPELERSPROFIEL.md stap 3). -->
      @if (!speler) {
        <app-storage-label></app-storage-label>
      }
    </div>
  </div>
</button>
}


<ng-template #menu>
  <div class="account-menu" role="menu" aria-labelledby="button-config" cdkMenu>
    <!-- Meekijken als deze gebruiker: bovenaan de weg terug. -->
    @if (meekijken) {
      <button class="account-menu-item btn-none" (click)="onStopMeekijken()" cdkMenuItem>
        <svg-icon src="assets/icons/logout.svg"></svg-icon>
        {{ 'MEEKIJKEN.stop' | translate: { naam: user.firstName } }}
      </button>
      <div class="account-menu-scheiding"></div>
    }
    <!-- Clubkiezer voor een super-admin (variant D, 24-10-2026): één regel
         met de huidige club; het venster zelf heeft zoeken en de hele lijst,
         zodat het menu kort blijft. -->
    @if (beheerderInClub) {
      <button class="account-menu-item btn-none omgeving" (click)="onWisselClub()" cdkMenuItem>
        <svg-icon src="assets/icons/club_album.svg"></svg-icon>
        <span class="omgeving-naam">{{ 'CLUB_KIEZER.menu' | translate }}</span>
        <span class="omgeving-huidig">{{ user.club_name }}</span>
      </button>
      <div class="account-menu-scheiding"></div>
    }
    <!-- Wisselen tussen de eigen club en de league-omgevingen. Clubs en
         leagues staan gescheiden (niet door elkaar), elk met eigen icoon. -->
    @if ((omgevingen$ | async); as omgevingen) {
      @if (omgevingen.length > 1) {
        @if (clubOmgevingen(omgevingen); as clubs) {
          @if (clubs.length > 0) {
            <div class="account-menu-kop">{{ 'HEADER.omgeving.clubs' | translate }}</div>
            @for (omgeving of clubs; track omgeving.club) {
              <button class="account-menu-item btn-none omgeving"
                      [class.aan]="omgeving.active"
                      [disabled]="omgeving.active || wisselt"
                      (click)="onWissel(omgeving)" cdkMenuItem>
                <svg-icon src="assets/icons/club_album.svg"></svg-icon>
                <span class="omgeving-naam">{{ omgeving.name }}</span>
              </button>
            }
          }
        }
        @if (leagueOmgevingen(omgevingen); as leagues) {
          @if (leagues.length > 0) {
            <div class="account-menu-kop">{{ 'HEADER.omgeving.leagues' | translate }}</div>
            @for (omgeving of leagues; track omgeving.club) {
              <button class="account-menu-item btn-none omgeving"
                      [class.aan]="omgeving.active"
                      [disabled]="omgeving.active || wisselt"
                      (click)="onWissel(omgeving)" cdkMenuItem>
                <svg-icon src="assets/icons/league.svg"></svg-icon>
                <span class="omgeving-naam">{{ omgeving.name }}</span>
                <span class="omgeving-soort">{{ 'HEADER.omgeving.league' | translate }}</span>
              </button>
            }
          }
        }
        <div class="account-menu-scheiding"></div>
      }
    }
    <a class="account-menu-item" routerLink="/profile" routerLinkActive="active" cdkMenuItem>
      <svg-icon src="assets/icons/user.svg"></svg-icon>
      {{ 'HEADER.profile' | translate }}
    </a>
    <!-- De ploegenkeuze zat als brede keuzelijst in de kopbalk; daar maakte
         hij het scherm onrustig terwijl je hem hooguit eens per sessie
         aanraakt (eigenaar 15-09-2026). -->
    <button class="account-menu-item btn-none" (click)="onTeams()" cdkMenuItem>
      <svg-icon src="assets/icons/players.svg"></svg-icon>
      {{ 'HEADER.teams_title' | translate }}
      @if (aantalPloegen(); as aantal) {
        <span class="account-menu-aantal">{{ aantal }}</span>
      }
    </button>
    <a *ngIf="permissions.eventSchema" class="account-menu-item" routerLink="/panels" routerLinkActive="active" cdkMenuItem>
      <svg-icon src="assets/icons/panel.svg"></svg-icon>
      {{ 'HEADER.nav.panels' | translate }}
    </a>
    <!-- Users en Team members zijn sinds 25-10-2026 één pagina. -->
    <a *ngIf="beheertLeden && permissions.usersShow" class="account-menu-item" routerLink="/users" routerLinkActive="active" cdkMenuItem>
      <svg-icon src="assets/icons/players.svg"></svg-icon>
      {{ 'HEADER.nav.users' | translate }}
    </a>
    <!-- Usage: de clubbeheerder, of met het vinkje "Can see usage" (01-11-2026). -->
    <a *ngIf="usageZien$ | async" class="account-menu-item" routerLink="/monitoring" routerLinkActive="active" cdkMenuItem>
      <svg-icon src="assets/icons/players.svg"></svg-icon>
      {{ 'HEADER.nav.monitoring' | translate }}
    </a>
    <a *ngIf="isClubAdmin" class="account-menu-item" routerLink="/event-data" routerLinkActive="active" cdkMenuItem>
      <svg-icon src="assets/icons/tag.svg"></svg-icon>
      {{ 'HEADER.nav.event_data' | translate }}
    </a>
    <!-- "Clubs" (club albums) is weg voor een club (eigenaar 03-11-2026): een
         tegenstander kies je via het zoeken, de eigen club maakt het platform
         zelf aan. In een league blijft League › Clubs hieronder. -->
    <!-- League naast Clubs: zelfde album-scherm, maar eerst naar de
         league-omgeving wisselen als je daar nog niet in zit. -->
    @if ((omgevingen$ | async); as omgevingen) {
      @if (heeftLeague(omgevingen)) {
        <button class="account-menu-item btn-none"
                [class.active]="inLeagueOmgeving(omgevingen)"
                (click)="onOpenLeague(omgevingen)"
                cdkMenuItem>
          <svg-icon src="assets/icons/league.svg"></svg-icon>
          {{ 'HEADER.nav.leagues' | translate }}
        </button>
      }
    }
    <!-- Help -> "Getting started" (docs/ONBOARDING.md): de kaart op de
         startpagina terug, of de introductie opnieuw voor wie de vragen
         nooit beantwoordde. -->
    <button class="account-menu-item btn-none" (click)="onAanDeSlag()" cdkMenuItem>
      <svg-icon src="assets/icons/information-icon.svg" class="lijn-icoon"></svg-icon>
      {{ 'ONBOARDING.help.menu' | translate }}
    </button>
    <button class="account-menu-item btn-none" (click)="onLogout()" cdkMenuItem>
      <svg-icon src="assets/icons/logout.svg"></svg-icon>
      {{ 'HEADER.log_out' | translate }}
    </button>
  </div>
</ng-template>
